import apiService from '@/services/apiService'

const BASE = '/api/maintenance/fiscal'

const unwrap = (response) => response?.data?.data

export default {
  getCompany() {
    return apiService.get(`${BASE}/company`).then(unwrap)
  },
  getPublicBranding() {
    return apiService.get(`${BASE}/branding/public`).then(unwrap)
  },
  updateCompany(payload) {
    return apiService.put(`${BASE}/company`, payload).then(unwrap)
  },
  uploadCommercialLogo(payload) {
    return apiService.post(`${BASE}/branding/commercial-logo`, payload).then(unwrap)
  },
  getOperationalProfile(params = {}) {
    return apiService.get(`${BASE}/operational-profile`, params).then(unwrap)
  },
  updateOperationalProfile(payload) {
    return apiService.put(`${BASE}/operational-profile`, payload).then(unwrap)
  },
  listEstablishments() {
    return apiService.get(`${BASE}/establishments`).then(unwrap)
  },
  getEstablishment(establecimientoId) {
    return apiService.get(`${BASE}/establishments/${establecimientoId}`).then(unwrap)
  },
  createEstablishment(payload) {
    return apiService.post(`${BASE}/establishments`, payload).then(unwrap)
  },
  updateEstablishment(establecimientoId, payload) {
    return apiService.put(`${BASE}/establishments/${establecimientoId}`, payload).then(unwrap)
  },
  listPoints(establecimientoId) {
    return apiService.get(`${BASE}/establishments/${establecimientoId}/points`).then(unwrap)
  },
  createPoint(establecimientoId, payload) {
    return apiService.post(`${BASE}/establishments/${establecimientoId}/points`, payload).then(unwrap)
  },
  updatePoint(puntoId, payload) {
    return apiService.put(`${BASE}/points/${puntoId}`, payload).then(unwrap)
  },
  listTimbrados() {
    return apiService.get(`${BASE}/timbrados`).then(unwrap)
  },
  createTimbrado(payload) {
    return apiService.post(`${BASE}/timbrados`, payload).then(unwrap)
  },
  updateTimbrado(timbradoId, payload) {
    return apiService.put(`${BASE}/timbrados/${timbradoId}`, payload).then(unwrap)
  },
  listSeries(params = {}) {
    return apiService.get(`${BASE}/series`, params).then(unwrap)
  },
  createSeries(payload) {
    return apiService.post(`${BASE}/series`, payload).then(unwrap)
  },
  updateSeries(serieId, payload) {
    return apiService.put(`${BASE}/series/${serieId}`, payload).then(unwrap)
  },
  setDefaultSeries(serieId) {
    return apiService.post(`${BASE}/series/${serieId}/set-default`, {}).then(unwrap)
  },
  resolve(params = {}) {
    return apiService.get(`${BASE}/resolve`, params).then(unwrap)
  },
  listAtencionFiscal(params = {}) {
    return apiService.get(`${BASE}/atencion`, params).then(unwrap)
  },
  inutilizarNumeracion(payload) {
    return apiService.post(`${BASE}/inutilizar-numeracion`, payload).then(unwrap)
  },
  cancelSend(idVenta, payload) {
    return apiService.post(`${BASE}/sales/${idVenta}/cancel-send`, payload).then(unwrap)
  },
  // CFE-E3-001/E4: subida del export de configuración fiscal. `simular`
  // (default `true`) sólo devuelve el diff; `simular: false` aplica.
  importConfig(sucursalId, payload, { simular = true } = {}) {
    return apiService
      .post(`${BASE}/config-import/${sucursalId}?simular=${simular ? 'true' : 'false'}`, payload)
      .then(unwrap)
  },
  getLastConfigImport(sucursalId) {
    return apiService.get(`${BASE}/config-import/${sucursalId}/last`).then(unwrap)
  }
}
